import { ZonedDateTime } from '@js-joda/core';
import noop from 'lodash/noop';
import { useEffect } from 'react';
import { getTimeUntilMillis } from '../utils/date';

export const useDelayedCallback = (
  date: ZonedDateTime | null | undefined,
  cb: () => void,
) => {
  /**
   * for dates far in the past, the negative number can be too large and
   * cause setTimeout to not execute
   *
   * In March, dates in August cause setTimeout to not run
   *
   * Any dates in the past we just want to execute immediately, so it doesn't
   * if it's -1 or -1000000, as long as it runs
   */
  const timeRemaining = date ? Math.max(-1, getTimeUntilMillis(date)) : null;

  // if provided date is nullish, don't execute the timer
  useEffect(() => {
    const timer = timeRemaining ? setTimeout(cb, timeRemaining) : noop();
    return () => (timer ? clearTimeout(timer) : noop());
  }, [cb, timeRemaining]);
};
